import $ from 'jquery';
import { Overlay } from 'ol';
import 'ol-ext/dist/ol-ext.css';
import { Vector } from 'ol/layer';
import 'ol/ol.css';
import OverlayPositioning from 'ol/OverlayPositioning';
import { CloseMessage, ReadyMessage } from '../lib/messages';
import { LayerUIFactory } from '../lib/ui/layer';
import { GSAContextManager } from './gsa/GSAContextManager';
import { GSADispatcher } from './gsa/GSADispatcher';
import { GSAInteractionManager } from './gsa/GSAInteractionManager';
import { GSALayers } from "./gsa/GSALayers";
import { GSAMap } from './gsa/GSAMap';
import { GSAToolbar } from './gsa/GSAToolbar';
import { BaseLayerBox } from './layerbox/BaseLayerBox';
import { OverlayLayerBox } from './layerbox/OverlayLayerBox';
import { ThematicLayerBox } from './layerbox/ThematicLayerBox';
const DEBUG = false;
const debug_setup = (map, p_layer, ctx_mgr, i_mgr) => {
    console.info("Debug enabled. Available: map, parcelLayer, contextManager, interactionManager");
    window.map = map;
    window.parcelLayer = p_layer;
    window.contextManager = ctx_mgr;
    window.interactionManager = i_mgr;
};
document.body.oncontextmenu = (e) => e.preventDefault();
const run = async (view) => {
    if (Config.MultipleBaseLayersEnabled) {
        LayerUIFactory.multiBaseLayersEnabled = true;
    }
    const map = await GSAMap.build(Config, view);
    let overlay_box = new OverlayLayerBox({ render_index: 2, ui_index: 1 });
    let baselayer_box = new BaseLayerBox({ render_index: 0, ui_index: 0 }, Config.MultipleBaseLayersEnabled);
    let thematic_layer_box = new ThematicLayerBox({ render_index: 1, ui_index: 2 });
    map.add_layerbox_components(baselayer_box, thematic_layer_box, overlay_box);
    overlay_box.label_layers.map(l => {
        if (l.visible) {
            map.addLayer(l.raw.unwrap());
            return l;
        }
        ;
    }).map(l => { if (l)
        l.visible = true; });
    const parcel_layer = GSALayers.parcel(view, GSAMap.config);
    const marker_layer = GSALayers.marker(parcel_layer);
    const sketch_layer = GSALayers.sketch;
    const group_layer = GSALayers.group;
    const measurement_layer = GSALayers.measure;
    const zoombox_layer = GSALayers.zoombox;
    const buffer_layer = GSALayers.buffer(parcel_layer, GSAMap.config);
    const loc_layer = GSALayers.location(parcel_layer, GSAMap.config, map);
    map.add_selection_layer(parcel_layer);
    map.add_client_layers(marker_layer, sketch_layer, group_layer, measurement_layer, zoombox_layer, buffer_layer, loc_layer);
    const ctx_manager = new GSAContextManager(map, parcel_layer, marker_layer, buffer_layer);
    const interaction_manager = new GSAInteractionManager(map, parcel_layer, sketch_layer);
    const toolbar = new GSAToolbar(parcel_layer, buffer_layer, loc_layer);
    map.addControl(toolbar);
    const dispatcher = new GSADispatcher(map, parcel_layer, sketch_layer, marker_layer, buffer_layer, ctx_manager);
    if (DEBUG)
        debug_setup(map, parcel_layer, ctx_manager, interaction_manager);
    ctx_manager.update_context('singleton');
    map.ready();
    const map_pointer_handler = (event) => {
        if (event.dragging)
            return;
        const pixel = map.getEventPixel(event.originalEvent);
        let features = map.get_features_at_pixel(pixel);
        let r_features = features.filter(v => v[1] === parcel_layer.raw).map(v => v[0]);
        if (r_features.length === 0) {
            $('#status-content').remove();
            parcel_layer.hovered = '';
            return;
        }
        const f = r_features[0];
        parcel_layer.hovered = f.get(parcel_layer.identifier);
        let content = $('<div id="status-content"></div>');
        if (parcel_layer.colorized) {
            const field = parcel_layer.color_manager.fields.selected.unwrapOr('');
            content.html(`Parcel ${parcel_layer.identifier}: ${parcel_layer.hovered}, ${field}: ${f.get(field)}`);
        }
        else {
            content.html(`Parcel ${parcel_layer.identifier}: ${parcel_layer.hovered}`);
        }
        $('#status-content').remove();
        $('#status-bar').append(content);
    };
    const handle_parcel_click = (coord, alt) => {
        ctx_manager.context.map(c => c.click_handler(coord, alt));
    };
    map.on('pointermove', evt => {
        ctx_manager.context
            .filter(c => !c.has_measure || c.name === 'group')
            .mapOr(interaction_manager.pointer_handler(evt), _ => map_pointer_handler(evt));
    });
    map.on('click', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let b = $(evt.originalEvent.target).closest('button.tooltip-close-button');
            if (b.length) {
                b.trigger('click');
                evt.stopPropagation();
                return;
            }
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
        if (!sketch_layer.isLayerActive) {
            ctx_manager.context
                .filter(c => !c.has_measure)
                .map(_ => handle_parcel_click(evt.coordinate, evt.originalEvent.shiftKey));
        }
    });
    map.on('contextmenu', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
        const box = $('#feature-info-box');
        box.html('');
        box.append($(`<div class="feature-info-title"><h5>Feature(s) Info</h5><button class="tooltip-close-button"><i class="fas fa-times" title="Close"></i></button></div>`));
        $('.feature-info-title button').on('click', () => { box.addClass('hidden'); });
        let content = $(`<div id="feature-info-content"></div>`);
        box.append(content);
        const pixel = map.getEventPixel(evt.originalEvent);
        map.get_features_at_pixel(pixel).map(x => {
            const feature = x[0];
            const layer = x[1];
            if (!layer || !feature) {
                return;
            }
            const name = layer.get('name');
            if (name && (layer instanceof Vector)) {
                const f = feature;
                let section = $(`<div id="feature-info-section"><h5>${name}</h5></div>`);
                f.getKeys().map(k => {
                    if (k === "geometry")
                        return;
                    let v = f.get(k);
                    if (!v)
                        return;
                    section.append(create_info_row(k, v));
                });
                content.append(section);
            }
        });
        if (!content.children().length) {
            box.addClass('hidden');
        }
        else {
            const popup = new Overlay({
                element: box.get(0),
                position: evt.coordinate,
                stopEvent: false,
            });
            map.addOverlay(popup);
            box.removeClass('hidden');
            popup.setPositioning(calculate_positioning());
        }
        function create_info_row(title, value) {
            let isUrl = false;
            let anchorTag = '';
            try {
                const url = new URL(value.trim());
                isUrl = true;
                anchorTag = `<a href="${url}" target="_blank">${value}</a>`;
            }
            catch (_) { }
            let label = $(`<div class="feature-info-row">${title}: ${isUrl ? anchorTag : value}</div>`);
            return label;
        }
        function calculate_positioning() {
            var _a, _b;
            let box_width = (_a = box.width()) !== null && _a !== void 0 ? _a : 270;
            let box_height = (_b = box.height()) !== null && _b !== void 0 ? _b : 300;
            let map_width = map.getSize() ? map.getSize()[0] : 0;
            let map_height = map.getSize() ? map.getSize()[1] : 0;
            let r_box_width = box_width + evt.originalEvent.clientX;
            let r_box_height = box_height + evt.originalEvent.clientY;
            if (r_box_width >= map_width && r_box_height >= map_height) {
                return OverlayPositioning.BOTTOM_RIGHT;
            }
            else if (r_box_height >= map_height) {
                return OverlayPositioning.BOTTOM_LEFT;
            }
            else if (r_box_width >= map_width) {
                return OverlayPositioning.TOP_RIGHT;
            }
            else {
                return OverlayPositioning.TOP_LEFT;
            }
        }
    });
    map.on('wheel', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.on('pointerdrag', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.on('dblclick', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.once('rendercomplete', _ => {
        if (Config.DisplayLayersListBox) {
            toolbar.display_layers_list();
        }
    });
    $(window).on('message', (msg) => {
        const message = msg.originalEvent;
        if (message.data.command !== 'SET VIEW')
            dispatcher.dispatch(message.data);
    }).on('beforeunload', () => {
        CloseMessage.send();
    });
};
window.addEventListener('message', msg => {
    if (msg.data.command === 'SET VIEW') {
        if (window.map)
            delete window.map;
        $('#map').html('<div id="popup"></div>');
        $('#layerbox').html('');
        $('#thematicbox').html('');
        run(msg.data.view);
    }
});
window.onload = () => setTimeout(() => ReadyMessage.send(), 250);
